import React, { Fragment, useState, useEffect } from 'react';
import './style.sass';

function Option({ value, text }) {
    return (
        <option value={String(value)}>{text}</option>)
}

export default function SelectType({ ...params }) {

    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        className = "",
    } = params

    return (
        <div className={`fileset1 ${className}`}>
            <select
                name={name}
                id={id}
                onChange={change}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                defaultValue=""
            >
                <option value="" disabled>{placeholder}</option>
                {options
                    ?
                    options.map((value, ind) =>
                        <Fragment key={ind}>
                            <Option value={value.numero} text={value.numero} />
                        </Fragment>
                    )
                    : null
                }
            </select>
            {/* <label htmlFor={id}>{placeholder}</label> */}
            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}


function OptionAD({ value, text }) {
    return (
        <option value={value}>{text}</option>
    )
}

export function SelectTypeAD({ ...params }) {

    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        className = ""
    } = params

    return (
        <div className={`fileset1 ${className}`}>
            <select
                name={name}
                id={id}
                onChange={change}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                defaultValue=""
                className="selectAD"
            >
                <option value="" disabled>{placeholder}</option>

                {options && options.map((value, ind) =>
                    <Fragment key={ind}>
                        <OptionAD value={value.id} text={value.name} />
                    </Fragment>
                )}

            </select>
            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}

export function SelectTypeADDesktop({ ...params }) {

    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        label
    } = params

    return (
        <div className="fileset1 desktInput">
            <label htmlFor={id}>{label}</label>
            <select
                name={name}
                id={id}
                onChange={change}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                defaultValue=""
                className="selectAD bottomDesktop"
            >
                <option value="" disabled>{placeholder}</option>

                {options && options.map((value, ind) =>
                    <Fragment key={ind}>
                        <OptionAD value={value.id} text={value.name} />
                    </Fragment>
                )}

            </select>
            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}


export function ClasicSelectType({ ...params }) {

    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        className = ""
    } = params

    return (
        <div className={`fileset1 ${className}`}>
            <select
                name={name}
                id={id}
                onChange={change}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                defaultValue=""
            >
                <option value="" disabled>Selecciona una {placeholder}</option>
                {options
                    ?
                    options.map((value, ind) =>
                        <Fragment key={ind}>
                            {value?.id
                                ?
                                    <Option value={value?.id} text={value?.value} />
                                :
                                    <Option value={value} text={value} />
                            }
                        </Fragment>
                    )
                    : null
                }
            </select>
            <label htmlFor={id}>{placeholder}</label>
            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}

export function ClasicSelectTypeNew({ ...params }) {

    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        className = ""
    } = params

    const [classA, setClassA] = useState()
    const selectedAction = () =>{
        if(document.querySelector(`#${id} option:checked`).index !== 0){
            setClassA('checked')
        }
    }
    useEffect(()=>{
        selectedAction()
    },[])

    return (
        <div className={`fileset3 ${className}`}>
            <select
                name={name}
                id={id}
                onChange={change}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                onChange={selectedAction}
                defaultValue=""
                className={classA}
            >
                <option value="" disabled></option>
                {options
                    ?
                        options.map((value, ind) =>
                            <Fragment key={ind}>
                                {typeof(value) === 'string'
                                    ?
                                        <Option value={value} text={value} />
                                    :
                                        <Option value={value?.id} text={value?.value} />
                                }
                            </Fragment>
                        )
                    : null
                }
            </select>
            <label htmlFor={id}>{placeholder}</label>
            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}



export function SelectFloatingLabel({ ...params }) {
    const {
        name,
        id,
        placeholder,
        change,
        focus,
        errorMessage,
        refs,
        readonly,
        disabled,
        options,
        optionsState,
        children,
        label
    } = params

    const [seleccion, setSeleccion] = useState(false);
    const clickC = (e) => {
        setSeleccion(e.target.value);
    }


    return (
        <div className="did-floating-label-content">
            <select
                name={name}
                id={id}
                onFocus={focus}
                readOnly={readonly}
                disabled={disabled}
                ref={refs}
                value={optionsState}
                defaultValue=""
                className="did-floating-select"
                onClick={clickC}
                onChange="this.setAttribute('value', this.value);"
            >
                <option value="" disabled></option>
                {options && options.map((value, ind) =>
                    <Fragment key={ind}>
                        <OptionAD value={value.id} text={value.value} />
                    </Fragment>
                )}
            </select>
            <label className={seleccion !== false && seleccion != ""? "did-floating-label topS" : "did-floating-label"} htmlFor={id}>{placeholder}</label>

            {children}

            {errorMessage
                ? <div className="error">{errorMessage}</div>
                : null
            }
        </div>
    )
}
